import { Link } from "react-router-dom";
import { convertDateInReadableFormat } from "../../Helper/Methods";

const getEmailId = (data: string) => {
    if (!data) return
    const parts = data.split("_");
    return parts[0]
}

export const actionTextGenerator = (allData: any) => {
    const actionType = allData.operationType;

    if (actionType === "EC/IRB Informed") {
        const type = allData?.entityType;
        const allAttachmentData = allData?.valueAfter?.allAttachmentData;
        const statement: any = {
            1: `EC/IRB ${allData?.valueAfter?.notificationDate ? `informed on ${convertDateInReadableFormat(allData?.valueAfter?.notificationDate)}` : 'will be informed using other menthods.'}`,
            2: `EC/IRB informed, email sent to ${allData?.valueAfter?.emailSentTo}.`,
            3: <>EC/IRB not informed because:<br /> "{allData?.valueAfter?.reason}"</>
        };

        return (
            <>
                <div>{statement[type] || 'NA'}</div>
                {allAttachmentData?.length ?
                    <div style={{ marginTop: "10px" }}>
                        <div>Attachments:</div>
                        <ol style={{ marginLeft: "21px" }}>
                            {allAttachmentData.map((data: any) => {
                                return (
                                    <li>
                                        <Link key={data?.id} to={data?.url}>
                                            {data?.name}.{data.type}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ol>
                    </div> : <></>
                }
            </>
        );
    }
    else if (actionType === "Notification Acknowledged") {
        const emailId = getEmailId(allData.ref.distributionId);
        const allAttachmentData = allData?.valueAfter?.allAttachmentData;
        return (
            <>
                <div>Notification Acknowledged by {emailId}</div>
                {allAttachmentData?.length ?
                    <div style={{ marginTop: "5px" }}>
                        <div>Attachments:</div>
                        <ol style={{ marginLeft: "21px", }}>
                            {allAttachmentData.map((data: any) => {
                                return (
                                    <li>
                                        <Link key={data?.id} to={data?.url}>
                                            {data?.name}.{data.type}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ol>
                    </div> : <></>
                }
            </>
        );
    }
    else if (actionType === "Notification Sent") {
        const emailId = getEmailId(allData.ref.distributionId);
        return `Notification Sent to ${emailId}`;
    }
    else if (actionType === "Reminder Sent") {
        const emailId = getEmailId(allData.ref.distributionId);
        return `Reminder Sent to ${emailId}`;
    }
    else if (actionType === "Distribution Created") {
        const emailId = getEmailId(allData?.valueAfter?.id);
        const name = allData?.valueAfter?.name;
        const siteName = allData?.valueAfter?.siteName;
        const siteNumber = allData?.valueAfter?.siteNumber;
        const role = allData?.valueAfter?.roleTitle;
        const studyNumber = allData?.valueAfter?.studyNumber;
        return (
            <>
                <div>Distribution Details:</div>
                <ul style={{ marginLeft: "21px" }}>
                    <li>Name: {name}</li>
                    <li>Email ID: {emailId}</li>
                    <li>Role: {role}</li>
                    <li>Site Name: {siteName}</li>
                    <li>Site Number: {siteNumber}</li>
                    <li>Study Number: {studyNumber}</li>
                </ul>
            </>
        );
    }
    else if (actionType === "Distribution Updated") {
        const emailId = getEmailId(allData.ref.distributionId);
        const allAttachmentData = allData?.valueAfter?.allAttachmentData;
        return (
            <>
                <div>Distribution Updated for {emailId}</div>
                {allAttachmentData?.length ?
                    <div style={{ marginTop: "5px" }}>
                        <div>Attachments:</div>
                        <ol style={{ marginLeft: "21px", }}>
                            {allAttachmentData.map((data: any) => {
                                return (
                                    <li>
                                        <Link key={data?.id} to={data?.url}>
                                            {data?.name}.{data.type}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ol>
                    </div> : <></>
                }
            </>
        )
    }
    else if (actionType === "Report Updated") {
        return "Safety Document Data Updated"
    }
    else if (actionType === "Report Created") {
        const creationType = allData?.meta?.creationType;
        return `New Safety Document Created via ${creationType === "xml" ? "Manual XML Upload" : "Create Document"}`;
    }
    else if (actionType === "Distribution Imported") {
        return (
            <>
                <div>Distribution Imported using this file:</div>
                {allData?.valueAfter?.allAttachmentData.map((data: any) => {
                    return (
                        <div>
                            <Link key={data?.id} to={data?.url}>
                                {data?.name}.{data.type}
                            </Link>
                        </div>
                    )
                })}
            </>
        )

    }
    else if (actionType === "Sent Notification Viewed") {
        const emailId = getEmailId(allData.ref.distributionId);
        return `Notification viewed by ${emailId}`;
    }
    return "-";
}

